import styled from "styled-components"

export const PopupContentWithImage = styled.div`
  display: flex;
  margin-bottom: 24px;
`

export const ImageStyled = styled.img`
  max-width: 71px;
  width: 100%;
  object-fit: contain;
  margin-right: 8px;
`